import React from 'react';

export default class FormSubmit extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="FormSubmit">
				<button
					onClick={this.props.onSubmit}
					className={
						'w-full md:w-68 my-3 bg-gray-300 text-center text-lg rounded-md'
					}
					disabled={this.props.disabled}
				>
					<p className="text-lg py-2 px-8 text-black hover:underline">
						{this.props.label || 'Save'}
					</p>
				</button>
			</div>
		);
	}
}
